module.exports = __webpack_public_path__ + "static/media/img_63.a778216c.png";